<div class="canvas-container">
    <div class="d-flex flex-column">
        <mat-label [ngClass]="id.includes('readonly') ? 'disabled' : 'enabled d-flex flex-row align-items-center'">
            {{ labelText }}
        </mat-label>
        <div [class]="'canvas-wrapper ' + (id.includes('initial') ? 'initial-wrapper' : 'signature-wrapper')">
            <canvas class="canvas" ref="hintTextCanvas" #hintTextCanvas></canvas>
            <canvas [id]="id" class="canvas" [ngClass]="id.includes('readonly') ? 'disabled' : 'enabled'" ref="canvas" #canvas> </canvas>
        </div>
        <mat-error *ngIf="error">
            {{ labelText }}
            <span *ngIf="labelText === 'Signature'">is</span>
            <span *ngIf="labelText === 'Initials'">are</span>
            required
        </mat-error>
        <div *ngIf="!hideButton">
            <button id="clear-{{ id }}" class="btn-small" class="clear-btn" (click)="clearCanvas()">Clear</button>
        </div>
    </div>
</div>
